import { useState } from "react";
import { Loader2, MailCheck } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "@/lib/apiClient";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";

export const ForgotPasswordDialog = ({ open, onOpenChange }) => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally { setLoading(false); }
  };

  const close = (o) => { onOpenChange(o); if (!o) { setSent(false); setEmail(""); } };

  return (
    <Dialog open={open} onOpenChange={close}>
      <DialogContent className="max-w-md" data-testid="forgot-password-dialog">
        <DialogHeader>
          <DialogTitle className="font-heading">Mot de passe oublié</DialogTitle>
          <DialogDescription>Saisissez votre email : nous vous enverrons un lien valable 1 heure.</DialogDescription>
        </DialogHeader>
        {sent ? (
          <div className="text-center py-4" data-testid="forgot-password-sent">
            <MailCheck className="h-10 w-10 mx-auto text-emerald-600" />
            <p className="mt-3 text-sm">Si un compte existe pour cet email, un lien de réinitialisation vient d'être envoyé.</p>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <div><Label htmlFor="forgot-email">Email</Label><Input id="forgot-email" data-testid="forgot-password-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1.5" /></div>
            <Button type="submit" disabled={loading} data-testid="forgot-password-submit" className="w-full h-11 bg-blue-700 hover:bg-blue-800">
              {loading ? <Loader2 className="h-5 w-5 animate-spin" /> : "Envoyer le lien"}
            </Button>
          </form>
        )}
      </DialogContent>
    </Dialog>
  );
};
